import { useEffect, useState, useRef } from 'react';
import { Redirect, withRouter } from 'react-router-dom';
import { io } from 'socket.io-client';
import Constants from '../../../constants/constants';
import Carousel from './Carousel';
import mixpanel from 'mixpanel-browser';

const EVENT_NAME = 'Therapy_SkillsUI_Dashboard_Click';

const Multiplayer = ({ location }) => {
  const socketClientRef = useRef();

  const [hasRooms, setHasRooms] = useState(false);
  const [multiplayerRoomId, setMultiplayerRoomId] = useState(-1);
  const [roomList, setRoomList] = useState([]);

  useEffect(() => {
    const socket = io(Constants.GAME_SERVER_URL, { transports: ['websocket'], reconnectionAttempts: 10 });

    socket.on('roomList', function (data) {
      setRoomList(data);
    });

    socketClientRef.current = socket;

    socket.emit('roomListSub');

    return () => {
      socket.removeAllListeners();
    };
  }, []);

  useEffect(() => {
    setHasRooms(roomList.length > 0);
  }, [roomList.length]);

  return (
    <div>
      {multiplayerRoomId !== -1 && (
        <Redirect
          push
          to={{ pathname: `/play/multiplayer/${multiplayerRoomId}`, state: { from: location.pathname } }}
        />
      )}

      {hasRooms ? (
        <Carousel
          slides={roomList}
          handleRoomSelect={(gameName, roomKey) => {
            mixpanel.track(EVENT_NAME, { Action: 'LiveGame', LiveGame: gameName });
            setMultiplayerRoomId(roomKey);
          }}
        />
      ) : (
        <></>
      )}
    </div>
  );
};

export default withRouter(Multiplayer);
